<template>
  <div class="text-center">
    <h4 class="text-h5 font-weight-bold empty-state-title">
      {{ title }}
    </h4>
    <div class="img-wrapper">
      <img
        :src="image"
        alt=""
      >
    </div>
    <p
      v-if="message"
      class="empty-state-message"
    >
      {{ message }}
    </p>
    <slot name="message" />
  </div>
</template>
<script>
export default {
  name: 'EmptyState',
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
<style lang="scss" scoped>
.img-wrapper {
  margin: 24px 0;
  min-height: 300px;
}
</style>
